/**
 * holds filters tree
 */

// const findInQuery = (rules, searchTrim) =>
//   rules.some(r => {
//     if (r.group) return findInQuery(r.group.rules, searchTrim);
//     const val = r.label || r.value;
//     return val && val.toLowerCase().indexOf(searchTrim) !== -1;
//   });

export class FiltersService {
  constructor(
    $q,
    FilterResource,
    globalAlert,
    $rootScope,
    AlertModalService,
  ) {
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.FilterResource = FilterResource;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;
    this.filters = [];
    this.loading = false;
    this.loadingFilters = {};
    this.searchedFilters = {
      all: true,
      searchTrim: ''
    };
    this.loadedChildren = {};
    this.loadedFilters = {};

    this.openedFilters = {
      all: false
    };
  }

  searchFilters(predicate) {
    const searchedFilters = {
      all: !predicate
    };
    if (!predicate) return searchedFilters;

    const findIter = (filters) => {
      let foundFilter = false;
      filters.map(f => {
        if (predicate(f)) {
          searchedFilters[f.id] = true;
          foundFilter = true;
        }
        if (f.children && f.children.length) {
          if (findIter(f.children)) {
            searchedFilters[f.id] = true;
            foundFilter = true;
          }
        }
      });
      return foundFilter;
    };
    findIter(this.filters);
    return searchedFilters;
  }

  searchFiltersId(id) {
    id && this.FilterResource.search('', id).then(res => {
      if (res && res.length) {
        res.map(fId => {
          this.openedFilters[fId] = true;
        });
      }
    });
  }

  searchFiltersTrim(searchTrim) {
    this.loadOther().then(() => {
      this.searchedFilters = {
        all: !(searchTrim && searchTrim.length > 2),
        searchTrim: searchTrim
      };

      searchTrim && this.FilterResource.search(searchTrim).then(res => {
        if (res && res.length) {
          res.map(fId => {
            this.searchedFilters[fId] = true;
          });
        }
      });
    });
  }

  load(id = null) {
    if (this.loadingFilters[id]) {
      return this.$q.resolve().then(() => {});
    }
    return this.$q.resolve()
      .then(() => {
        if (id) {
          this.loadingFilters[id] = true;
        }
        this.loading = true;
        return this.FilterResource.list(id);
      })
      .then(filters => {
        if (id === null) {
          this.filters = filters;
        } else {
          this.loadedChildren[id] = true;
          const parentFilter = this.findById(id);

          if (parentFilter) parentFilter.children = filters;
          else {
            this.AlertModalService.open(gettext('Фильтр удален'),
              gettext('Фильтр') + ` "${id}" ` + gettext('удален'));
          }
        }
        filters.map(f => this.loadedFilters[f.id] = {
          parentId: id
        });
        this.setLoaded(filters);
      })
      .finally(() => {
        if (id) {
          this.loadingFilters[id] = false;
        }
        this.loading = false;
      });
  }

  setLoaded(_filters) {
    const iter = filters => {
      if (!filters.length) return null;
      filters.map(f => {
        this.loadedFilters[f.id] = true;
        if (!f.children) return null;
        iter(f.children);
      });
    };
    iter(_filters);
  }

  loadOther(id = null) {
    return this.$q.resolve()
      .then(() => {
        this.loading = true;
        if (this.loadedFilters.all) return null;
        if (id && (id in this.loadedFilters)) return null;
        return this.FilterResource.listOther(this.loadedFilters, id);
      })
      .then(data => {
        let parentId = -1;
        let parentFilter;
        if (!data) return null;
        data.map(f => {
          if (f.id in this.loadedFilters) return;
          if (f.parent_id) {
            if (f.parent_id !== parentId) {
              parentId = f.parent_id;
              parentFilter = this.findById(parentId);
            }
            if (parentFilter && parentFilter.children) parentFilter.children.push(f);
          } else {
            this.filters.push(f);
          }
          this.loadedFilters[f.id] = {
            parentId: f.parent_id
          };
          this.loadedChildren[f.parent_id] = true;
          if (id) {
            this.openedFilters[f.parent_id] = true;
          }
        });
        if (!id) this.loadedFilters.all = true;
        else {
          if (!this.$rootScope.$$phase) this.$rootScope.$apply();
        }

      })
      .finally(() => {
        this.loading = false;
      });
  }


  save(filter) {
    const flt = angular.copy(filter);
    delete flt.dIndex;
    return this.FilterResource.save(flt)
      .then(({
        status,
        data,
        error
      }) => {
        if (error) {
          this.globalAlert(error.message);
          return;
        }
        const originalFilter = this.findById(data.id);
        Object.assign(filter, data);
        if (originalFilter) {
          Object.keys(originalFilter).map(k => delete originalFilter[k]);
          Object.assign(originalFilter, data);
        } else if (!filter.dIndex) this.filters.push(filter);

        filter.isChanged = false;
        if (filter.id) this.loadedFilters[filter.id] = true;
        return data;
      });
  }

  find(predicate) {
    for (let i = 0; i < this.filters.length; ++i) {
      const filter = this.filters[i];
      const f = filter.find(predicate);
      if (f) {
        return f;
      }
    }
  }

  findById(id) {
    return this.find(f => f.id == id);
  }

  getPath(filter) {
    for (let i = 0; i < this.filters.length; ++i) {
      const f = this.filters[i];
      const path = f.getPath(filter);
      if (path) {
        return path;
      }
    }
    return [];
  }

  findCardFilter(dim) {
    return this.find(filter =>
        filter.isDimensionCard && filter.dimension === dim) ||
      this.getDefaultCardFilter(dim);
  }

  getCardFilter(dim) {
    const promiceFunc = (resolutionFunc) => {
      const cardFilter = this.findCardFilter(dim);
      if (!cardFilter) {
        this.loadOther().then(() => {
          return resolutionFunc(this.findCardFilter(dim));
        });
      } else resolutionFunc(cardFilter);
    };
    return new Promise(promiceFunc);
  }

  getDefaultCardFilter(dim) {
    dim = dim.split('@')[0];
    return this.find(filter =>
      filter.isDimensionCard && filter.dimension.startsWith(dim));
  }

  onDeleteFilter(filter) {
    const path = this.getPath(filter);
    if (path.length) {
      path.pop().removeChild(filter);
    } else {
      this.filters = this.filters.filter((f) => f.id != filter.id);
    }
  }

  delete(filter) {
    return this.FilterResource.delete(filter)
      .then(({
        status,
        data,
        error
      }) => {
        if (error) {
          this.globalAlert(error.message);
          // return;
        }
        this.onDeleteFilter(filter);
        // this.filters = this.filters.filter((f) => f.id != filter.id);
      })
      .catch((error) => {
        this.globalAlert(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/filters.service.js